import { render, staticRenderFns } from "./ExamList.vue?vue&type=template&id=0df9170e&scoped=true&"
import script from "./ExamList.vue?vue&type=script&lang=js&"
export * from "./ExamList.vue?vue&type=script&lang=js&"
import style0 from "./ExamList.vue?vue&type=style&index=0&id=0df9170e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df9170e",
  null
  
)

export default component.exports